<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M11.99,24.001c-0.47,0-0.939-0.12-1.356-0.348c-0.665-0.363-1.149-0.964-1.362-1.691c-0.117-0.397,0.111-0.814,0.508-0.931
		c0.069-0.02,0.14-0.03,0.211-0.03c0.33,0,0.626,0.221,0.72,0.538c0.101,0.343,0.329,0.626,0.642,0.798
		c0.197,0.107,0.417,0.164,0.638,0.164c0.127,0,0.255-0.019,0.379-0.055c0.438-0.129,0.777-0.468,0.906-0.906
		c0.093-0.317,0.389-0.539,0.72-0.539c0.071,0,0.141,0.01,0.21,0.03c0.397,0.117,0.626,0.534,0.509,0.931
		c-0.273,0.931-0.992,1.65-1.923,1.923C12.53,23.962,12.26,24.001,11.99,24.001z"/>
	<path d="M2.991,19.501c-0.285,0-0.549-0.165-0.674-0.421c-0.127-0.26-0.094-0.563,0.083-0.791c0.006-0.009,1.341-1.939,1.341-7.788
		c0-4.293,3.266-7.835,7.5-8.216V0.751c0-0.414,0.336-0.75,0.75-0.75s0.75,0.336,0.75,0.75v1.534c4.234,0.381,7.5,3.923,7.5,8.216
		c0,6.303,1.246,7.686,1.258,7.699c0.218,0.199,0.297,0.532,0.187,0.818c-0.114,0.293-0.387,0.483-0.695,0.483H2.991z
		 M19.701,18.001c-0.482-1.232-0.961-3.47-0.961-7.5c0-3.722-3.028-6.75-6.75-6.75s-6.75,3.028-6.75,6.75
		c0,3.957-0.58,6.277-1.046,7.5H19.701z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'alarm-bell',
    },
    name: {
      type: String,
      required: false,
      default: 'AlarmBell',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>